import React from 'react';
import { Select, SelectProps } from '@economic/taco';
import { t } from '@lingui/macro';
import { ScrollableListItem } from '@economic/taco/dist/components/Listbox/ScrollableList';
import { UnitModel } from '~/types/internal-api';
import useCachedQuery from '../../hooks/useCachedQuery';
import { copyObjectWithoutProp } from '../../util/utilities/copyObjectWithoutProp';

export default function UnitDropdown({
    emptyValueText,
    includeNoneOption,
    ...props
}: SelectProps & { emptyValueText?: string; includeNoneOption?: boolean }) {
    const query = useCachedQuery<{ data: UnitModel[] }>('setup/units?pagesize=1000', []);
    let newProps = props;
    const data: ScrollableListItem[] = (query.data?.data || []).map(unit => ({
        text: unit.name,
        value: unit.unitNo,
        data: unit,
    }));

    if (includeNoneOption && data.length > 0) {
        data.unshift({
            text: t`(none)`,
            value: 0,
        });
    }

    // workaround for emptyValue prop implementation since original implementation causes issue in EC-33766
    if (props.hasOwnProperty('emptyValue')) {
        newProps = copyObjectWithoutProp(props, 'emptyValue');
        if (data.length > 0) {
            data.unshift({
                text: emptyValueText || '',
                value: null,
            });
        }
    }

    return <Select {...newProps} data={data} loading={query.loading} className="w-24" />;
}
